var gaBoolean = function gaBoolean(data) {
  if (data === undefined) return undefined;
  return data && (!Array.isArray(data) || data.length) ? 'verdadeiro' : 'falso';
};
export default gaBoolean;